export const PADDINGS = 48
export const BUTTONS_SECTION_HEIGHT = 70